/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Data_X13_Action_FailedInputs */

const en_data_x13_action_failed = /** @type {(inputs: Data_X13_Action_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That did not work. Please try again in a moment.`)
};

/** @type {(inputs: Data_X13_Action_FailedInputs) => LocalizedString} */
const ar_data_x13_action_failed = en_data_x13_action_failed;

/** @type {(inputs: Data_X13_Action_FailedInputs) => LocalizedString} */
const he_data_x13_action_failed = en_data_x13_action_failed;

/** @type {(inputs: Data_X13_Action_FailedInputs) => LocalizedString} */
const ur_data_x13_action_failed = en_data_x13_action_failed;

/** @type {(inputs: Data_X13_Action_FailedInputs) => LocalizedString} */
const es_data_x13_action_failed = en_data_x13_action_failed;

/** @type {(inputs: Data_X13_Action_FailedInputs) => LocalizedString} */
const fr_data_x13_action_failed = en_data_x13_action_failed;

/** @type {(inputs: Data_X13_Action_FailedInputs) => LocalizedString} */
const de_data_x13_action_failed = en_data_x13_action_failed;

/** @type {(inputs: Data_X13_Action_FailedInputs) => LocalizedString} */
const pt_data_x13_action_failed = en_data_x13_action_failed;

/** @type {(inputs: Data_X13_Action_FailedInputs) => LocalizedString} */
const hi_data_x13_action_failed = en_data_x13_action_failed;

/** @type {(inputs: Data_X13_Action_FailedInputs) => LocalizedString} */
const bn_data_x13_action_failed = en_data_x13_action_failed;

/**
* | output |
* | --- |
* | "That did not work. Please try again in a moment." |
*
* @param {Data_X13_Action_FailedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const data_x13_action_failed = /** @type {((inputs?: Data_X13_Action_FailedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Data_X13_Action_FailedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_data_x13_action_failed(inputs)
	if (locale === "he") return he_data_x13_action_failed(inputs)
	if (locale === "ur") return ur_data_x13_action_failed(inputs)
	if (locale === "es") return es_data_x13_action_failed(inputs)
	if (locale === "fr") return fr_data_x13_action_failed(inputs)
	if (locale === "de") return de_data_x13_action_failed(inputs)
	if (locale === "pt") return pt_data_x13_action_failed(inputs)
	if (locale === "hi") return hi_data_x13_action_failed(inputs)
	if (locale === "bn") return bn_data_x13_action_failed(inputs)
	return /** @type {LocalizedString} */ ("That did not work. Please try again in a moment.")
});